// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Portal_ServiceOrders_ListResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /customer-portal/v1/service-orders/list
 *
 * Keyset-paginated (created_at DESC, order_id DESC). Zero matches — unknown
 * document, or a document with no orders — is 200 with empty `data`, never
 * 404 (conventions.md §2, same rule /clientes already follows).
 *
 * Field names are English per ADR-0014 §3 — only the three envelope keys
 * {success, dados, error} stay as they are.
 */
import type { Portal_ServiceOrders_OrderRow } from './Portal_ServiceOrders_OrderRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Portal_ServiceOrders_ListResponseDados {
document: string
data: Portal_ServiceOrders_OrderRow[]
next_cursor?: string
}

export type Portal_ServiceOrders_ListResponse = ApiResponse<Portal_ServiceOrders_ListResponseDados>;

registerResponseContract('Portal_ServiceOrders_ListResponse', {
  document:    { type: 'string',  required: true },
  data: {
    type: 'array',
    required: true,
    items: {
      order_id:               { type: 'number',  required: true },
      franchise: {
        type: 'object',
        required: true,
        fields: {
          id:    { type: 'string',  required: true },
          name:  { type: 'string',  required: true },
          city:  { type: 'string',  required: false },
          state: { type: 'string',  required: false },
        },
      },
      status:                 { type: 'string',  required: true },
      created_at:             { type: 'string',  required: true },
      total_cents:            { type: 'number',  required: true },
      currency:               { type: 'string',  required: false },
      items_count:            { type: 'number',  required: true },
      delivered_items_count:  { type: 'number',  required: true },
      expected_delivery_at:   { type: 'string',  required: false },
      first_item_description: { type: 'string',  required: false },
      subtotal_cents:         { type: 'number',  required: false },
      payment: {
        type: 'object',
        required: true,
        fields: {
          total_cents: { type: 'number',  required: true },
          paid_cents:  { type: 'number',  required: true },
          status:      { type: 'string',  required: true },
        },
      },
    },
  },
  next_cursor: { type: 'string',  required: false },
})
